// PERSISTENT Thumbnail Fix - Prevents Theme JS from Reverting Changes
(function() {
  'use strict';
  
  let fixInterval;
  let hasRun = false;
  
  function applyThumbnailFix() {
    // Find thumbnail navigation
    const thumbnailItems = document.querySelectorAll('.t4s-carousel__nav-item');
    const mainSlides = document.querySelectorAll('[data-main-slide]');
    const fallbackAlt = document.querySelector('h1')?.textContent?.trim() || 'Product image';
    
    if (thumbnailItems.length === 0) {
      return false;
    }
    
    let fixedCount = 0;
    
    // Fix each thumbnail
    thumbnailItems.forEach(function(thumbItem, index) {
      const thumbInner = thumbItem.querySelector('.t4s-carousel__nav-inner, .t4s_ratio');
      
      if (!thumbInner) return;
      
      // Force square aspect ratio PERSISTENTLY
      thumbInner.style.setProperty('--aspect-ratioapt', '1', 'important');
      thumbInner.style.aspectRatio = '1 / 1';
      thumbInner.style.width = '100%';
      thumbInner.style.height = '100%';
      thumbInner.style.overflow = 'hidden';
      thumbInner.style.position = 'relative';
      const thumbImg = thumbInner.querySelector('img');
      if (thumbImg && !thumbImg.getAttribute('alt')) {
        thumbImg.alt = fallbackAlt;
        fixedCount++;
      }
      
      // Get corresponding main slide image
      if (index < mainSlides.length) {
        const mainSlide = mainSlides[index];
        const mainImg = mainSlide.querySelector('img');
        
        if (mainImg) {
          let imageUrl = mainImg.src || mainImg.getAttribute('data-src');
          const imageAlt = mainImg.getAttribute('alt') || document.querySelector('h1')?.textContent?.trim() || 'Product image';
          
          // Try picture source if no img src
          if (!imageUrl) {
            const picture = mainSlide.querySelector('picture source');
            if (picture && picture.srcset) {
              imageUrl = picture.srcset.split(' ')[0];
            }
          }
          
          if (imageUrl) {
            // Use smaller image for thumbnails
            imageUrl = imageUrl.replace(/width=\d+/g, 'width=120');
            
            // Set background image as PRIMARY method
            thumbInner.style.backgroundImage = `url(${imageUrl})`;
            thumbInner.style.backgroundSize = 'cover';
            thumbInner.style.backgroundPosition = 'center';
            thumbInner.style.backgroundRepeat = 'no-repeat';
            
            // ALSO update img element with persistent styles
            if (thumbImg) {
              thumbImg.src = imageUrl;
              thumbImg.alt = imageAlt;
              thumbImg.style.width = '100%';
              thumbImg.style.height = '100%';
              thumbImg.style.objectFit = 'cover';
              thumbImg.style.objectPosition = 'center';
              thumbImg.style.display = 'block';
            }
            
            // Mark as persistently fixed
            thumbInner.setAttribute('data-persistent-fix', 'true');
            fixedCount++;
          }
        }
      }
    });
    
    return fixedCount > 0;
  }
  
  function startPersistentFix() {
    // Apply fix immediately
    if (applyThumbnailFix()) {
      hasRun = true;
    }
    
    // Set up continuous monitoring to prevent reversion
    fixInterval = setInterval(function() {
      // Check if thumbnails need re-fixing
      const thumbnailItems = document.querySelectorAll('.t4s-carousel__nav-item');
      let needsFix = false;
      
      thumbnailItems.forEach(function(thumbItem) {
        const thumbInner = thumbItem.querySelector('.t4s-carousel__nav-inner, .t4s_ratio');
        if (thumbInner && !thumbInner.hasAttribute('data-persistent-fix')) {
          needsFix = true;
        }
      });
      
      if (needsFix || !hasRun) {
        applyThumbnailFix();
        hasRun = true;
      }
    }, 1000); // Check every second
    
    // Also monitor for DOM changes
    const observer = new MutationObserver(function(mutations) {
      let thumbnailsChanged = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || mutation.type === 'attributes') {
          const target = mutation.target;
          if (target.classList && (
            target.classList.contains('t4s-carousel__nav-item') ||
            target.querySelector('.t4s-carousel__nav-item') ||
            target.closest('.t4s-carousel__nav-item')
          )) {
            thumbnailsChanged = true;
          }
        }
      });
      
      if (thumbnailsChanged) {
        setTimeout(applyThumbnailFix, 100);
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
  }
  
  // Start when DOM is ready
  if (document.readyState !== 'loading') {
    startPersistentFix();
  } else {
    document.addEventListener('DOMContentLoaded', startPersistentFix);
  }
  
  // Also start after delays to catch any dynamic loading
  setTimeout(startPersistentFix, 1000);
  setTimeout(startPersistentFix, 3000);
})();
